@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.svarside-container {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  padding-top: 2rem;

  @media (max-width: map.get($grid-breakpoints, md)) {
    column-gap: 2rem;
    padding-right: 1rem;
    padding-top: 1rem;
  }

  &__answer {
    margin-bottom: 2rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 1rem;
    }

    &--margin {
      margin-bottom: 1rem;

      @media (max-width: map.get($grid-breakpoints, md)) {
        margin-bottom: 0.5rem;
      }
    }
  }

  &__text {
    white-space: pre-line;
    vertical-align: bottom;
    font-family: Avenir, Montserrat, Poppins, serif;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2.25rem;
    text-align: left;
    color: #fff;

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 1rem;
      line-height: 1.3rem;
    }

    &--undertekst {
      color: white;
    }
  }

  &__arrow-wrapper {
    display: flex;
    align-items: center;
    column-gap: 3.87rem;
    margin-top: 2rem;
    margin-bottom: 1rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      column-gap: 1.5rem;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
